export function isTmapScheme(scheme: string) {
  return scheme.startsWith('tmap://');
}

export function parseSchemeToOpenServiceByNameParams(scheme: string) {
  const url = new URL(scheme);
  const serviceName = url.hostname;
  const jsonData = Object.fromEntries(url.searchParams);

  return {
    serviceName,
    jsonData,
  };
}
